import React from 'react'
import { useTranslation } from 'react-i18next'
import {Col, Divider, List as AntList, Modal, Row, Typography} from 'antd'
import {ExclamationCircleOutlined} from '@ant-design/icons'
import {hasPermissions} from '@/stores/auth/services/utils'
import {PermissionsMap} from '@/stores/auth/constants/permissions-map'
import {Switch} from '@/components'
import {PaymentMethodStoreSettingProps} from './props'
import { SWITCH_TERMINAL, TERMINAL_STATUS } from '@/constants/playwright-ids'

const {Item} = AntList

export const PaymentMethodTerminalSetting: React.FC<PaymentMethodStoreSettingProps> = (
    {terminalId, checked, onSwitchChange, extra}
) => {
    const { t } = useTranslation()
    const confirm = (checked: boolean) => {
        Modal.confirm({
            icon: <ExclamationCircleOutlined />,
            content: t('PaymentMethodTerminalSetting.areYouSureYouWantTo', { context: checked ? 'enable' : 'disable' }),
            okText: t('PaymentMethodTerminalSetting.yes'),
            cancelText: t('PaymentMethodTerminalSetting.no'),
            onOk: () => onSwitchChange(terminalId, checked)
        })
    }

    return (
        <Item actions={[
            <Row key={'row'} gutter={[16, 16]} justify={'space-between'}>
                <Col>
                    <Typography.Text type={checked ? 'success' : 'danger'} data-test-id={TERMINAL_STATUS}>
                        {checked ? t('PaymentMethodTerminalSetting.active') : t('PaymentMethodTerminalSetting.disabled')}
                    </Typography.Text>
                </Col>
                {
                    hasPermissions([PermissionsMap.payment_methods.full]) &&
                    <>
                        <Col>
                            <Switch
                                data-test-id={SWITCH_TERMINAL}
                                key={'active'}
                                title={'Active'}
                                checked={checked}
                                onChange={confirm}
                            />
                            {
                                extra ? (
                                    <>
                                        <Divider type={'vertical'}/>
                                        {extra}
                                    </>
                                ) : null
                            }
                        </Col>
                    </>
                }
            </Row>
        ]}>
            {terminalId}
        </Item>
    )
}
